//#region src/components/ui/tag-selector/locale/en_US.ts
var e = {
	placeholder: "Select a tag...",
	searchPlaceholder: "Search tags...",
	noOptionsAvailable: "No options available",
	createSentence: "Create '{{value}}'"
};
//#endregion
export { e as tagSelectorLocale };

//# sourceMappingURL=en_US.js.map